export default function formatLocale(locale) {
  if (locale && locale.includes('_')) {
    return locale.split('_').join('-');
  }
  return locale;
}
